import { render, staticRenderFns } from "./SpotifyPlaylistsPanel.vue?vue&type=template&id=7282482e&"
import script from "./SpotifyPlaylistsPanel.vue?vue&type=script&lang=js&"
export * from "./SpotifyPlaylistsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports